/* eslint-disable no-empty-label */
const tag = {
  state: {
    visitedViews: []
  },
  mutations: {
    ADD_VISITED_VIEW: (state, view) => {
      if (state.visitedViews.some((v) => v.path === view.path)) {
        return
      }
      const tag = {
        meta: view.meta,
        fullPath: view.fullPath,
        path: view.path,
        tagName: view.meta.tagName || 'no-name',
        query: view.query
      }
      state.visitedViews.push(tag)
      // state.visitedViews.push(
      //   //这种加法有点粗暴，最好选择有用的，不然存在JSON报错
      //   Object.assign({}, view, {
      //     tagName: view.meta.tagName || 'no-name'
      //   })
      // )
    },
    INIT_VISITED_VIEWS: (state, views) => {
      state.visitedViews = views
    },
    DEL_VISITED_VIEW: (state, view) => {
      for (const [i, v] of state.visitedViews.entries()) {
        if (v.path === view.path) {
          state.visitedViews.splice(i, 1)
          break
        }
      }
    },

    DEL_OTHERS_VISITED_VIEWS: (state, view) => {
      state.visitedViews = state.visitedViews.filter((v) => {
        return v.meta.fixTag || v.path === view.path
      })
    },
    DEL_RIGHT_VISITED_VIEWS: (state, view) => {
      let index = state.visitedViews.findIndex((v) => {
        return v.path === view.path
      })
      if (index >= 0) {
        state.visitedViews = state.visitedViews.slice(0, index + 1)
      }
    },

    UPDATE_VISITED_VIEW: (state, view) => {
      for (let v of state.visitedViews) {
        if (v.path === view.path) {
          v = Object.assign(v, view)
          break
        }
      }
    }
  },
  actions: {
    //更新自缓存（主要存在刷新后 tag消失问题）
    updateStorageTags({ getters, state }) {
      getters.sessionStorage.setItem('TAGS', window.JSON.stringify([...state.visitedViews]))
    },
    emptyTags({ getters }) {
      getters.sessionStorage.removeItem('TAGS')
    },
    initTags({ getters, commit }) {
      let tagsJson = getters.sessionStorage.getItem('TAGS')
      let tagList = JSON.parse(tagsJson)
      if (tagList instanceof Array) {
        commit('INIT_VISITED_VIEWS', tagList || [])
      }
    },
    addView({ commit, dispatch }, view) {
      commit('ADD_VISITED_VIEW', view)
      dispatch('updateStorageTags')
    },
    delView({ commit, state }, view) {
      return new Promise((resolve) => {
        commit('DEL_VISITED_VIEW', view)
        resolve({
          visitedViews: [...state.visitedViews]
        })
      })
    },

    delOthersViews({ commit, state }, view) {
      return new Promise((resolve) => {
        commit('DEL_OTHERS_VISITED_VIEWS', view)
        resolve([...state.visitedViews])
      })
    },
    delRightViews({ commit, state }, view) {
      return new Promise((resolve) => {
        commit('DEL_RIGHT_VISITED_VIEWS', view)
        resolve([...state.visitedViews])
      })
    },
    updateVisitedView({ commit }, view) {
      commit('UPDATE_VISITED_VIEW', view)
    }
  }
}

export default tag



// WEBPACK FOOTER //
// ./src/store/modules/tag.js